<template>
  <div>
    <v-toolbar color="deep-orange darken-3" dark tabs>
      <v-btn icon class="hidden-xs-only" @click="back()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title>กลุ่ม {{ sectionItem.name }}({{ sectionItem.code }})</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text">วิชา {{ sectionItem.activeCourse.subject.label }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text">ปีการศึกษาที่ {{ sectionItem.activeCourse.academicYear.semesterYear }}</v-toolbar-title>
      <v-tabs
        slot="extension"
        v-model="model"
        centered
        color="deep-orange darken-3"
        slider-color="yellow"
      >
        <v-tab
          v-for="i in tabItems"
          :key="i.name"
          :href="`#tab-${i.name}`"
          class="subheading"
        >
          {{ i.label }}
        </v-tab>
      </v-tabs>
    </v-toolbar>
    <v-tabs-items v-model="model">
      <v-tab-item
        v-for="i in tabItems"
        :key="i.name"
        :value="`tab-${i.name}`"
      >
        <component :is="i.name" :sectionItem="sectionItem" :allowedRoles="hasAccess(allowedRoles)"></component>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { hasAccessMixin } from '@/mixins/hasAccessMixin'
import swal from 'sweetalert2'
import SectionInfo from './section'
import SubSectionInfo from './subSection'
import DepartmentInfo from './department'

export default {
  mixins: [ hasAccessMixin ],
  components: {
    SectionInfo,
    SubSectionInfo,
    DepartmentInfo
  },
  data () {
    return {
      allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE'],
      tabItems: [
        { name: 'section-info', label: 'ข้อมูลกลุ่มใหญ่' }, 
        { name: 'sub-section-info', label: 'กลุ่มย่อย' }, 
        { name: 'department-info', label: 'ภาควิชา' }, 
      ],
      model: 'tab-section-info'
    }
  },
  computed: {
    ...mapGetters({
        sectionItem: 'section/sectionItem'
    }),

  },
  mounted () {
    // console.log("sectionItem", this.sectionItem)
    if(this.sectionItem.activeCourse.subject.subjectType === "ELECTIVE") this.tabItems.splice(1, 1)
  },
  methods: {
    back () {
      // this.$router.go(-1)
      this.$router.push({ name: 'section', params: { activeCourseId: this.sectionItem.activeCourse.id, allowedRoles: this.hasAccess(this.allowedRoles) }})
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/course/section/shows/index.vue